import {Form} from "antd";
import DgForm from "../../../custom/data-entry/form";
import Content from "./content";
import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import {getWeighingStationById, updateWeighingStation} from "../../../api/weighingStation";
import {onReloadData} from "../../../redux/actions/layout/interaction/action";

const Update = ({id, onCancel})=>{

    const [form] = Form.useForm()
    const dispatch = useDispatch()
    const { reloadData} = useSelector(state => state.layoutInteractionReducer)
    const [status, setStatus] = useState("active")

    useEffect(()=>{
        getWeighingStationById(id).then(r => {
            setStatus(r.status)
            form.setFieldsValue({
                ...r,
                customerId: r.customerId === 0 ? undefined : r.customerId
            });
        })
            .catch(()=>{})
    },[form , id])

    const onFinish = (value) => {

        value ={
            ...value,
            status : status,
            customerId : value.customerId !== null || value.customerId !== 0 ? value.customerId : 0
        }
        updateWeighingStation(id, value).then(r =>{
            dispatch(onReloadData(!reloadData))
            onCancel()
        })
            .catch(ex=>{})
    }

    return (
        <>
            <DgForm
                name="basic"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                autoComplete="off"
                form={form}
                mode={"add"}
                onFinish={onFinish}
                colon={false}
                labelAlign="left"
                scrollToFirstError={true}
            >

                <Content form={form}
                         customer={true}
                         id={id}
                         status={status}
                         setStatus={(value) => setStatus(value ? "active" : "inactive")}/>
            </DgForm>
        </>
    )
}

export default Update
